import { useCallback } from "react";
import { useBrowseMorphemePageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.browse.morpheme.navigator";

/** Shared by every word level in one list, so each surface stays hook-light. */
export function useWordLevelsListState({
  columns,
  tileSize,
}: {
  columns: number;
  tileSize: number;
}) {
  const push = useBrowseMorphemePageNavigator().push.mutate;
  const onNavigate = useCallback((word: string) => push({ morpheme: word, params: {} }), [push]);
  return { columns, onNavigate, tileSize };
}

export type WordLevelsListState = ReturnType<typeof useWordLevelsListState>;
